import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Info from "../../components/pages/PrivacyPolicy/Info/Info";

const PrivacyPolicyPage: React.FC = () => {
  return (
    <Layout>
      <Info />
      <Feedback />
    </Layout>
  );
};

export default PrivacyPolicyPage;
